import { render, staticRenderFns } from "./SpiderChart.vue?vue&type=template&id=5e629b0d&"
import script from "./SpiderChart.vue?vue&type=script&lang=js&"
export * from "./SpiderChart.vue?vue&type=script&lang=js&"
import style0 from "./SpiderChart.vue?vue&type=style&index=0&id=5e629b0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports